var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoCasoExito(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ico_caso_de_exito",
    "data-name": "ico_caso de exito",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_87",
    "data-name": "Rect\\xE1ngulo 87",
    width: 100,
    height: 100,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_169",
    "data-name": "Grupo 169",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_306",
    "data-name": "Trazado 306",
    d: "M100,50A50,50,0,1,1,50,0a50,50,0,0,1,50,50",
    transform: "translate(0 -0.001)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_307",
    "data-name": "Trazado 307",
    d: "M105.229,47.391a6.8,6.8,0,0,1,5.925,3.486,6.723,6.723,0,0,1,.014,6.783,6.924,6.924,0,0,1,.007,11.917,6.9,6.9,0,0,1-5.934,10.3,6.872,6.872,0,0,1-10.3,5.923,6.878,6.878,0,0,1-11.9.023,6.874,6.874,0,0,1-10.276-5.906,6.923,6.923,0,0,1-5.946-10.331,6.911,6.911,0,0,1,.02-11.908A6.879,6.879,0,0,1,72.753,47.39a6.881,6.881,0,0,1,10.292-5.935,6.91,6.91,0,0,1,11.907,0,6.626,6.626,0,0,1,6.831.018,6.839,6.839,0,0,1,3.446,5.92M75.093,79.3c-.208,3.181,2.014,5.435,5.053,5.1a6.416,6.416,0,0,0,2.439-1.028c1.007-.606,1.739-.44,2.132.649a4.584,4.584,0,0,0,8.637-.149,1.187,1.187,0,0,1,1.71-.738,6.119,6.119,0,0,1,.7.488,4.67,4.67,0,0,0,5.284.024,4.432,4.432,0,0,0,1.715-4.892.6.6,0,0,1,.012-.383,1.439,1.439,0,0,1,1.69-.85A4.573,4.573,0,0,0,109,70.379a5.211,5.211,0,0,1-.544-.828,1.128,1.128,0,0,1,.574-1.517,4.579,4.579,0,0,0,.227-8.73,1.193,1.193,0,0,1-.609-1.957c.122-.175.268-.334.391-.508a4.579,4.579,0,0,0,.018-5.154,4.374,4.374,0,0,0-4.712-1.882.932.932,0,0,1-1.223-.487,1.906,1.906,0,0,1-.2-1.071,4.667,4.667,0,0,0-2.083-4.745,4.453,4.453,0,0,0-5.308.306c-.983.767-1.828.554-2.244-.566a4.592,4.592,0,0,0-4.36-2.974,4.541,4.541,0,0,0-4.29,3.249.908.908,0,0,1-.366.468,1.38,1.38,0,0,1-1.709-.119,4.505,4.505,0,0,0-5.424-.361,4.445,4.445,0,0,0-1.876,5.016.683.683,0,0,1-.093.444,1.473,1.473,0,0,1-1.673.779,4.448,4.448,0,0,0-5.039,2.9,4.414,4.414,0,0,0,.884,4.649,1.2,1.2,0,0,1-.315,1.859c-.243.143-.524.22-.78.343a4.586,4.586,0,0,0,.373,8.408,1.25,1.25,0,0,1,.629,2.173,4.562,4.562,0,0,0,4.7,7.338.861.861,0,0,1,.605.151,1.552,1.552,0,0,1,.534,1.738",
    transform: "translate(-37.989 -22.788)",
    fill: "#ffce01"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_308",
    "data-name": "Trazado 308",
    d: "M78.616,171.291c2.527-5.318,5.915-9.871,9.109-14.633l1.86,1.228c-.473.7-.935,1.351-1.362,2.024-2.274,3.586-4.579,7.152-6.782,10.781a32.844,32.844,0,0,0-1.811,3.936,1.371,1.371,0,0,1-1.867.916.894.894,0,0,1-.422-.566c-.629-2.233-1.234-4.473-1.864-6.775-.6.288-1.266.582-1.907.918-1.617.848-3.235,1.7-4.829,2.587-.462.258-.816.393-1.26-.016a1.2,1.2,0,0,1-.454-1.44c.443-1.073.859-2.159,1.36-3.206a92.273,92.273,0,0,1,7.263-11.814c.426-.627.856-1.25,1.323-1.929l1.838,1.237c-1.517,2.252-3.058,4.439-4.49,6.694-1.418,2.232-2.727,4.534-4.084,6.805l.194.169c1.027-.512,2.052-1.028,3.082-1.536q1.085-.534,2.179-1.049a1.139,1.139,0,0,1,1.783.861c.348,1.427.653,2.864.978,4.3.024.108.067.212.163.511",
    transform: "translate(-40.083 -91.809)",
    fill: "#ffce01"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_309",
    "data-name": "Trazado 309",
    d: "M127.509,158.984l1.85-1.275c1.523,2.262,3.079,4.464,4.518,6.74s2.744,4.6,4.145,6.959c.189-.792.392-1.6.574-2.411.15-.67.3-1.342.409-2.02a1.226,1.226,0,0,1,1.887-1.029c1.607.759,3.2,1.557,4.793,2.337.14.069.285.126.573.253-2.164-4.544-5.007-8.483-7.775-12.59l1.856-1.274c1.446,2.165,2.88,4.258,4.258,6.388a50.934,50.934,0,0,1,4.71,8.841c.553,1.394.462,1.66-.777,2.448l-7.439-3.915c-.619,2.287-1.21,4.477-1.8,6.665-.108.4-.126.821-.756.816s-1.193-.044-1.475-.714c-.294-.7-.561-1.409-.871-2.1a73.07,73.07,0,0,0-6.664-11.17c-.655-.959-1.309-1.919-2.012-2.95",
    transform: "translate(-76.362 -92.631)",
    fill: "#ffce01"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_310",
    "data-name": "Trazado 310",
    d: "M101,93.14A17.6,17.6,0,0,1,83.444,75.7a17.6,17.6,0,0,1,17.447-17.611h.065a17.575,17.575,0,0,1,17.538,17.5,17.5,17.5,0,0,1-17.458,17.55Zm-.1-32.447A15,15,0,0,0,86.043,75.686,14.992,14.992,0,0,0,101,90.541h.032A14.9,14.9,0,0,0,115.895,75.6a14.974,14.974,0,0,0-14.939-14.908H100.9",
    transform: "translate(-49.972 -34.791)",
    fill: "#ffce01"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_311",
    "data-name": "Trazado 311",
    d: "M110.954,73.265l3.559,6.912,7.319.991-4.971,4.884.816,7.9L110.954,90.4l-6.723,3.554.856-7.9-5.011-4.884,7.461-.849Z",
    transform: "translate(-59.934 -43.877)",
    fill: "#ffce01"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoCasoExito);
export default __webpack_public_path__ + "static/media/ico_caso_exito.06b5d7e42f77a04d95861a8b981ce74e.svg";
export { ForwardRef as ReactComponent };